import React, { useState } from "react";
import { sendInfo, trudMotivTestData } from "../../data/TrudMotivTestData";
import { trudMotivTestAnalysis } from "./helpers/trudMotivTestAnalysis";
import QuestionSection from "./QuestionSection";
import TextInputSection from "./TextInputSection";
import sendEmail from "../../helpers/sendEmail";
import { useNavigate } from "react-router-dom";
import { getPdfUrl, postTestResult } from "../../shared/api/results";
import { personalizePDF } from "./helpers/personalizePDF";
import { capitalizeFullName } from "../../helpers/capitalizeFullName";

const TrudMotivForm = () => {
  const [answers, setAnswers] = useState({});
  const [fio, setFio] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const test = "Мотивация на деятельность";
  const navigate = useNavigate();

  const handleAnswerChange = (questionId, optionId) => {
    setAnswers((prevAnswers) => {
      const currentAnswers = prevAnswers[questionId] || [];
      const isSelected = currentAnswers.includes(optionId);

      if (
        trudMotivTestData
          .find((q) => q.id === "questions")
          ?.questions.find((q) => q.id === questionId)?.maxChoices > 1
      ) {
        if (
          !isSelected &&
          currentAnswers.length >=
            trudMotivTestData
              .find((q) => q.id === "questions")
              ?.questions.find((q) => q.id === questionId)?.maxChoices
        ) {
          alert("Максимальное количество выбранных вариантов достигнуто.");
          return prevAnswers;
        }

        return {
          ...prevAnswers,
          [questionId]: isSelected
            ? currentAnswers.filter((id) => id !== optionId)
            : [...currentAnswers, optionId],
        };
      }

      return {
        ...prevAnswers,
        [questionId]: isSelected ? [] : [optionId], // Для radio – заменяем
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fio.trim()) {
      alert("Пожалуйста, введите ваше ФИО.");
      return;
    }
    const formattedFio = capitalizeFullName(fio)
    const unansweredQuestions = trudMotivTestData.filter(
      (section) =>
        section.type === "multiCheckbox" &&
        section.questions.some(
          (question) =>
            !answers[question.id] || answers[question.id].length === 0
        )
    );

    if (unansweredQuestions.length > 0) {
      alert("Пожалуйста, ответьте на все вопросы.");
      return;
    }

    const result = trudMotivTestAnalysis(answers);
    const scores = [
      result.result.in,
      result.result.pr,
      result.result.pa,
      result.result.ow,
      result.result.lu,
    ];

    setIsLoading(true);
    try {
      const response = await fetch("/motiv.pdf");
      if (!response.ok) throw new Error("PDF не найден");
      const buffer = await response.arrayBuffer();
      const score = result.readable;
      const clean = (str) =>
        str
          .trim()
          .replace(/[^\w\sа-яА-ЯёЁ-]/gi, "")
          .replace(/\s+/g, "_");

      const filename = `${clean(test)}_${clean(formattedFio) || "результат"}.pdf`;

      const personalizedBlob = await personalizePDF(buffer, formattedFio, scores);
      const formData = new FormData();
      formData.append("full_name", formattedFio);
      formData.append("test_name", test);
      formData.append("score", score);
      formData.append(
        "pdf",
        new File([personalizedBlob], filename, { type: "application/pdf" })
      );

      try {
        const result = await postTestResult(formData);

        const resultId = result.id;
        const pdfUrl = getPdfUrl(resultId);

        try {
          const directusSendInfo = {
            provider: "directus_flow",
            baseUrl: "https://crm-hr.kzn.ru",
            flowId: "9c0df71d-3ceb-4ab4-aa0c-a6806f3d89a6",
            token: "sGaLAYCUxT_HpfAaMiQNb4qzieuAtUAM",
            subjectPrefix: process.env.REACT_APP_DIRECTUS_SUBJECT_PREFIX || "HR Tests",
          };
          await sendEmail(undefined, test, formattedFio, score, pdfUrl, directusSendInfo);
        } catch (emailError) {
          console.error("Ошибка при отправке письма:", emailError);
        }

        navigate("/finish", {
          state: {
            fio: formattedFio,
            test: test,
            score: score,
            pdfUrl: pdfUrl,
            blob: personalizedBlob,
            fileName: filename,
          },
        });
      } catch (postError) {
        console.error("Ошибка при отправке результата:", postError);
        navigate("/finish", {
          state: {
            blob: personalizedBlob,
            fileName: filename,
          },
        });
      }
    } catch (error) {
      console.error("Ошибка при подготовке PDF или других данных:", error);

      navigate("/finish", {
        state: {
          error: "Не удалось подготовить результат в формате PDF.",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-xl font-semibold text-center mb-6">{test}</h1>
      <form onSubmit={handleSubmit}>
        {trudMotivTestData.map((section) =>
          section.type === "multiCheckbox" ? (
            <QuestionSection
              key={section.id}
              section={section}
              answers={answers}
              onAnswerChange={handleAnswerChange}
            />
          ) : (
            <TextInputSection
              key={section.id}
              section={section}
              fio={fio}
              setFio={setFio}
            />
          )
        )}
        <button
          type="submit"
          className={`w-full ${isLoading ? "bg-gray-400" : "bg-blue-500 hover:bg-blue-600"} text-lg  text-white py-2 px-4 rounded-md mt-4`}
          disabled={isLoading}
        >
          {isLoading ? "Отправка..." : "Отправить"}
        </button>
      </form>
    </div>
  );
};
export default TrudMotivForm;
